import * as Sentry from '@sentry/vue'

/**
 * Initialize Sentry error tracking.
 * Reads DSN and environment from meta tags in the layout.
 * Does nothing if no DSN is present (e.g. in development).
 *
 * @param {typeof Vue} VueInstance - The global Vue constructor
 */
export function initSentry(VueInstance) {
  const dsn = document.querySelector('meta[name="sentry-dsn"]')?.content
  if (!dsn) return

  const environment = document.querySelector('meta[name="rails-env"]')?.content || 'development'

  Sentry.init({
    Vue: VueInstance,
    dsn,
    environment,
    attachProps: true,
    logErrors: true,
  })
}
